import { Language } from "../../constants/language";
import { Event, EventStatus, EventCategory, EventMetadataType, RecurrencePattern, RecurrenceDuration } from "../../models/event/event";
import { EnrollmentMode } from "../../models/enrollment/enrollment";
import { PaginatedResult, PaginationUtil } from "../../utils/pagination-util";
import { MINISTRY_MOCK_DATA_EN, MINISTRY_MOCK_DATA_AR, MINISTRY_ID } from "../ministry/ministry-mock-data";
import { DateUtil } from "../../utils/date-util";
import {
  CHOSEN_SPORTS_DAY_MEDIA_EN,
  CHOSEN_SPORTS_DAY_MEDIA_AR,
  CHOSEN_WINTER_CONFERENCE_MEDIA_EN,
  CHOSEN_WINTER_CONFERENCE_MEDIA_AR,
  CHOSEN_SUMMER_CONFERENCE_MEDIA_EN,
  CHOSEN_SUMMER_CONFERENCE_MEDIA_AR,
  MONTHLY_WORSHIP_ENCOUNTER_MEDIA_EN,
  MONTHLY_WORSHIP_ENCOUNTER_MEDIA_AR,
} from "./event-media-data";
import { ADDRESS_TBD_AR, ADDRESS_TBD_EN, AGAPE_HOUSE_AR, AGAPE_HOUSE_EN } from "../address/addresses-data";
import { CONTACT_EN } from "../../models/contact/contact";

// Helper functions to get ministries directly from mock data
const getMinistryById = (id: number, language: Language) => {
  const ministryData = language === Language.AR ? MINISTRY_MOCK_DATA_AR : MINISTRY_MOCK_DATA_EN;
  return ministryData.find(m => m.id === id);
};

interface EventSchedule {
  id: number;
  startDate: string;
  endDate: string;
  slugSuffix: string;
  deadline: string;
}

/*******************
 * Youth Ministry Recurring Events
 *********************/
const YOUTH_MINISTRY_TUESDAYS_2026: EventSchedule[] = [
  { id: 1, startDate: "06-01-2026", endDate: "06-01-2026", slugSuffix: "2026-01-06", deadline: "" },
  { id: 2, startDate: "13-01-2026", endDate: "13-01-2026", slugSuffix: "2026-01-13", deadline: "" },
  { id: 3, startDate: "20-01-2026", endDate: "20-01-2026", slugSuffix: "2026-01-20", deadline: "" },
  { id: 4, startDate: "27-01-2026", endDate: "27-01-2026", slugSuffix: "2026-01-27", deadline: "" },
  { id: 5, startDate: "03-02-2026", endDate: "03-02-2026", slugSuffix: "2026-02-03", deadline: "" },
  { id: 6, startDate: "10-02-2026", endDate: "10-02-2026", slugSuffix: "2026-02-10", deadline: "" },
  { id: 7, startDate: "17-02-2026", endDate: "17-02-2026", slugSuffix: "2026-02-17", deadline: "" },
  { id: 8, startDate: "24-02-2026", endDate: "24-02-2026", slugSuffix: "2026-02-24", deadline: "" },
  { id: 9, startDate: "03-03-2026", endDate: "03-03-2026", slugSuffix: "2026-03-03", deadline: "" },
  { id: 10, startDate: "10-03-2026", endDate: "10-03-2026", slugSuffix: "2026-03-10", deadline: "" },
  { id: 11, startDate: "17-03-2026", endDate: "17-03-2026", slugSuffix: "2026-03-17", deadline: "" },
  { id: 12, startDate: "24-03-2026", endDate: "24-03-2026", slugSuffix: "2026-03-24", deadline: "" },
  { id: 13, startDate: "31-03-2026", endDate: "31-03-2026", slugSuffix: "2026-03-31", deadline: "" },
  { id: 14, startDate: "07-04-2026", endDate: "07-04-2026", slugSuffix: "2026-04-07", deadline: "" },
  { id: 15, startDate: "14-04-2026", endDate: "14-04-2026", slugSuffix: "2026-04-14", deadline: "" },
  { id: 16, startDate: "21-04-2026", endDate: "21-04-2026", slugSuffix: "2026-04-21", deadline: "" },
  { id: 17, startDate: "28-04-2026", endDate: "28-04-2026", slugSuffix: "2026-04-28", deadline: "" },
  { id: 18, startDate: "05-05-2026", endDate: "05-05-2026", slugSuffix: "2026-05-05", deadline: "" },
  { id: 19, startDate: "12-05-2026", endDate: "12-05-2026", slugSuffix: "2026-05-12", deadline: "" },
  { id: 20, startDate: "19-05-2026", endDate: "19-05-2026", slugSuffix: "2026-05-19", deadline: "" },
  { id: 21, startDate: "26-05-2026", endDate: "26-05-2026", slugSuffix: "2026-05-26", deadline: "" },
  { id: 22, startDate: "02-06-2026", endDate: "02-06-2026", slugSuffix: "2026-06-02", deadline: "" },
  { id: 23, startDate: "09-06-2026", endDate: "09-06-2026", slugSuffix: "2026-06-09", deadline: "" },
  { id: 24, startDate: "16-06-2026", endDate: "16-06-2026", slugSuffix: "2026-06-16", deadline: "" },
  { id: 25, startDate: "23-06-2026", endDate: "23-06-2026", slugSuffix: "2026-06-23", deadline: "" },
  { id: 26, startDate: "30-06-2026", endDate: "30-06-2026", slugSuffix: "2026-06-30", deadline: "" },
  { id: 27, startDate: "07-07-2026", endDate: "07-07-2026", slugSuffix: "2026-07-07", deadline: "" },
  { id: 28, startDate: "14-07-2026", endDate: "14-07-2026", slugSuffix: "2026-07-14", deadline: "" },
  { id: 29, startDate: "21-07-2026", endDate: "21-07-2026", slugSuffix: "2026-07-21", deadline: "" },
  { id: 30, startDate: "28-07-2026", endDate: "28-07-2026", slugSuffix: "2026-07-28", deadline: "" },
  { id: 31, startDate: "04-08-2026", endDate: "04-08-2026", slugSuffix: "2026-08-04", deadline: "" },
  { id: 32, startDate: "11-08-2026", endDate: "11-08-2026", slugSuffix: "2026-08-11", deadline: "" },
  { id: 33, startDate: "18-08-2026", endDate: "18-08-2026", slugSuffix: "2026-08-18", deadline: "" },
  { id: 34, startDate: "25-08-2026", endDate: "25-08-2026", slugSuffix: "2026-08-25", deadline: "" },
  { id: 35, startDate: "01-09-2026", endDate: "01-09-2026", slugSuffix: "2026-09-01", deadline: "" },
  { id: 36, startDate: "08-09-2026", endDate: "08-09-2026", slugSuffix: "2026-09-08", deadline: "" },
  { id: 37, startDate: "15-09-2026", endDate: "15-09-2026", slugSuffix: "2026-09-15", deadline: "" },
  { id: 38, startDate: "22-09-2026", endDate: "22-09-2026", slugSuffix: "2026-09-22", deadline: "" },
  { id: 39, startDate: "29-09-2026", endDate: "29-09-2026", slugSuffix: "2026-09-29", deadline: "" },
  { id: 40, startDate: "06-10-2026", endDate: "06-10-2026", slugSuffix: "2026-10-06", deadline: "" },
  { id: 41, startDate: "13-10-2026", endDate: "13-10-2026", slugSuffix: "2026-10-13", deadline: "" },
  { id: 42, startDate: "20-10-2026", endDate: "20-10-2026", slugSuffix: "2026-10-20", deadline: "" },
  { id: 43, startDate: "27-10-2026", endDate: "27-10-2026", slugSuffix: "2026-10-27", deadline: "" },
  { id: 44, startDate: "03-11-2026", endDate: "03-11-2026", slugSuffix: "2026-11-03", deadline: "" },
  { id: 45, startDate: "10-11-2026", endDate: "10-11-2026", slugSuffix: "2026-11-10", deadline: "" },
  { id: 46, startDate: "17-11-2026", endDate: "17-11-2026", slugSuffix: "2026-11-17", deadline: "" },
  { id: 47, startDate: "24-11-2026", endDate: "24-11-2026", slugSuffix: "2026-11-24", deadline: "" },
  { id: 48, startDate: "01-12-2026", endDate: "01-12-2026", slugSuffix: "2026-12-01", deadline: "" },
  { id: 49, startDate: "08-12-2026", endDate: "08-12-2026", slugSuffix: "2026-12-08", deadline: "" },
  { id: 50, startDate: "15-12-2026", endDate: "15-12-2026", slugSuffix: "2026-12-15", deadline: "" },
  { id: 51, startDate: "22-12-2026", endDate: "22-12-2026", slugSuffix: "2026-12-22", deadline: "" },
  { id: 52, startDate: "29-12-2026", endDate: "29-12-2026", slugSuffix: "2026-12-29", deadline: "" }
];

const generateYouthMinistryEvents = (language: Language): Event[] => {
  const ministryData = language === Language.AR ? MINISTRY_MOCK_DATA_AR : MINISTRY_MOCK_DATA_EN;
  const youthMinistry = ministryData.find(m => m.id === 4);
  
  if (!youthMinistry) {
    console.warn('Youth ministry not found');
    return [];
  }

  let startTime = '06:30 PM'; 
  let endTime = '09:30 PM';  
  
  if (youthMinistry.time) {
    const timeMatch = youthMinistry.time.match(/(\d{1,2}:\d{2})\s*(PM|AM|مساءً|صباحاً)?\s*-\s*(\d{1,2}:\d{2})\s*(PM|AM|مساءً|صباحاً)?/i);
    if (timeMatch) {
      const [, start, startPeriod, end, endPeriod] = timeMatch;
      
      // Convert to 24-hour format
      const convertTo24Hour = (time: string, period?: string) => {
        const [hours, minutes] = time.split(':').map(Number);
        let hour24 = hours;
        
        if (period && (period.toLowerCase().includes('pm') || period.includes('مساءً'))) {
          if (hour24 !== 12) hour24 += 12;
        } else if (period && (period.toLowerCase().includes('am') || period.includes('صباحاً'))) {
          if (hour24 === 12) hour24 = 0;
        } else if (!period && hours < 12) {
          // If no period specified and hour < 12, assume it needs PM conversion for evening times
          hour24 = hours < 7 ? hours + 12 : hours;
        }
        
        return `${hour24.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
      };
      
      startTime = convertTo24Hour(start, startPeriod);
      endTime = convertTo24Hour(end, endPeriod);
    }
  }

  return YOUTH_MINISTRY_TUESDAYS_2026.map((schedule) => {
    const eventDate = DateUtil.parseDateString(schedule.startDate); // Use DateUtil for proper DD-MM-YYYY parsing
    const eventId = 9000 + schedule.id; // Start from 9000 to avoid conflicts

    return {
      id: eventId,
      key: `${youthMinistry.key}-recurring`,
      title: youthMinistry.title,
      description: youthMinistry.description,
      shortDescription: youthMinistry.description,
      longDescription: youthMinistry.additionalInfo || youthMinistry.description,
      
      startDate: schedule.startDate,
      endDate: schedule.endDate,
      startTime: startTime,
      endTime: endTime,
      timezone: 'EET',
      
      address: youthMinistry.address,
      
      category: EventCategory.YOUTH_MEETING,
      tags: ['ministry', 'recurring', youthMinistry.category.toLowerCase()],
      
      status: eventDate < new Date() ? EventStatus.COMPLETED : EventStatus.UPCOMING,
      enrollment: {
        type: youthMinistry.hasEnrollment ? EnrollmentMode.OPTIONAL : EnrollmentMode.NONE,
        isRequired: false
      },
      
      media: youthMinistry.media,
      
      organizer: youthMinistry,
      contactInfo: CONTACT_EN,
      slug: `${youthMinistry.key}-${schedule.slugSuffix}`,
      featured: false,
      priority: 1,
      
      languageSupport: ['en', 'ar'],
      
      metadata: {
        type: EventMetadataType.MINISTRY_RECURRING,
        ministryId: youthMinistry.id.toString(),
        ministryKey: youthMinistry.key,
        recurrence: {
          pattern: RecurrencePattern.WEEKLY,
          dayOfWeek: 2, // Tuesday
          duration: RecurrenceDuration.ALL_YEAR
        }
      },
      
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    };
  });
};

const YOUTH_MINISTRY_EVENTS_EN = generateYouthMinistryEvents(Language.EN);
const YOUTH_MINISTRY_EVENTS_AR = generateYouthMinistryEvents(Language.AR);
/*******************
 * Monthly Worship Recurring Events
 *********************/
const MONTHLY_WORSHIP_OCCURRENCES_2026: EventSchedule[] = [
  { id: 1, startDate: "16-01-2026", endDate: "16-01-2026", slugSuffix: "2026-01-16", deadline: "" },
  { id: 2, startDate: "20-02-2026", endDate: "20-02-2026", slugSuffix: "2026-02-20", deadline: "" },
  { id: 3, startDate: "20-03-2026", endDate: "20-03-2026", slugSuffix: "2026-03-20", deadline: "" },
  { id: 4, startDate: "17-04-2026", endDate: "17-04-2026", slugSuffix: "2026-04-17", deadline: "" },
  { id: 5, startDate: "15-05-2026", endDate: "15-05-2026", slugSuffix: "2026-05-15", deadline: "" },
  { id: 6, startDate: "19-06-2026", endDate: "19-06-2026", slugSuffix: "2026-06-19", deadline: "" },
  { id: 7, startDate: "17-07-2026", endDate: "17-07-2026", slugSuffix: "2026-07-17", deadline: "" },
  { id: 8, startDate: "21-08-2026", endDate: "21-08-2026", slugSuffix: "2026-08-21", deadline: "" },
  { id: 9, startDate: "18-09-2026", endDate: "18-09-2026", slugSuffix: "2026-09-18", deadline: "" },
  { id: 10, startDate: "16-10-2026", endDate: "16-10-2026", slugSuffix: "2026-10-16", deadline: "" },
  { id: 11, startDate: "20-11-2026", endDate: "20-11-2026", slugSuffix: "2026-11-20", deadline: "" },
  { id: 12, startDate: "18-12-2026", endDate: "18-12-2026", slugSuffix: "2026-12-18", deadline: "" }
];

const generateMonthlyWorshipEvents = (language: Language): Event[] => {
  const ministryData = language === Language.AR ? MINISTRY_MOCK_DATA_AR : MINISTRY_MOCK_DATA_EN;
  const evangelismMinistry = ministryData.find(m => m.id === 6);
  
  if (!evangelismMinistry) {
    console.warn('Evangelism ministry not found');
    return [];
  }

  // Parse time - Worship events are typically evening events (convert to 24-hour format)
  const startTime = '10:00'; // 6:30 PM
  const endTime = '14:00';   // 9:30 PM

  return MONTHLY_WORSHIP_OCCURRENCES_2026.map((schedule) => {
    const eventDate = DateUtil.parseDateString(schedule.startDate); // Use DateUtil for proper DD-MM-YYYY parsing
    const eventId = 8000 + schedule.id; // Start from 8000 to avoid conflicts

    return {
      id: eventId,
      key: `${evangelismMinistry.key}-monthly-worship`,
      title: evangelismMinistry.title,
      description: evangelismMinistry.description,
      shortDescription: evangelismMinistry.schoolDescription ?? evangelismMinistry.description,
      longDescription: evangelismMinistry.additionalInfo || evangelismMinistry.description,
      
      startDate: schedule.startDate,
      endDate: schedule.endDate,
      startTime: startTime,
      endTime: endTime,
      timezone: 'EET',
      
      address: evangelismMinistry.address,
      
      category: EventCategory.MONTHLY_WORSHIP,
      tags: [],
      
      status: eventDate < new Date() ? EventStatus.COMPLETED : EventStatus.UPCOMING,
      enrollment: {
        type: EnrollmentMode.OPTIONAL,
        isRequired: false,
        capacity: 800,
        enrolled: 0,
        deadline: schedule.deadline,
        formUrl: `https://docs.google.com/forms/d/e/1FAIpQLSeQwXbNzKLdRfGhKjMnEJGFDsA7TcvBxWqYfZhR9PmNQsYvUw/viewform?usp=header`
      },
      
      media: language === Language.AR ? MONTHLY_WORSHIP_ENCOUNTER_MEDIA_AR : MONTHLY_WORSHIP_ENCOUNTER_MEDIA_EN,
      
      organizer: evangelismMinistry,
      contactInfo: CONTACT_EN,
      slug: `monthly-worship-encounter-${schedule.slugSuffix}`,
      featured: false,
      priority: 4,
      
      languageSupport: ['en', 'ar'],
      
      metadata: {
        type: EventMetadataType.MINISTRY_RECURRING,
        ministryId: evangelismMinistry.id.toString(),
        ministryKey: evangelismMinistry.key,
        recurrence: {
          pattern: RecurrencePattern.MONTHLY,
          duration: RecurrenceDuration.ALL_YEAR
        }
      },
      
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    };
  });
};

const MONTHLY_WORSHIP_EVENTS_EN = generateMonthlyWorshipEvents(Language.EN);
const MONTHLY_WORSHIP_EVENTS_AR = generateMonthlyWorshipEvents(Language.AR);

/*******************
 * Chosen Sports Day
 *********************/
const CHOSEN_SPORTS_DAY_OCCURRENCES_2026: EventSchedule[] = [
  { id: 15, startDate: "17-09-2026", endDate: "17-09-2026", slugSuffix: "2026-09-17", deadline: "07-09-2026" },
  { id: 16, startDate: "13-11-2026", endDate: "13-11-2026", slugSuffix: "2026-11-13", deadline: "03-11-2026" }
];

const CHOSEN_SPORTS_DAY_TAGS_EN = ["Chosen Generation", "sports", "fellowship", "discipleship", "youth"];
const CHOSEN_SPORTS_DAY_TAGS_AR = ["تشوزين", "رياضة", "شركة", "تلمذة", "شباب"];

const CHOSEN_GENERATION_CONTACT_EN = CONTACT_EN;

const CHOSEN_GENERATION_CONTACT_AR = CONTACT_EN;

const CHOSEN_SPORTS_DAY_BENEFITS_EN = [
  "Build deeper friendships within the Chosen Generation family.",
  "Discover leadership and teamwork through Spirit-led competition.",
  "Invite friends to encounter Jesus through joyful outreach moments.",
  "Experience a worship rally that anchors athletic passion to Christ."
];

const CHOSEN_SPORTS_DAY_BENEFITS_AR = [
  "بناء صداقات أعمق داخل عائلة تشوزين.",
  "اكتشاف القيادة والعمل الجماعي من خلال منافسة يقودها الروح.",
  "دعوة الأصدقاء لمقابلة يسوع عبر لحظات كرازية مبهجة.",
  "التمتع برالي عبادة يربط الشغف الرياضي بشخص المسيح."
];

const CHOSEN_SPORTS_DAY_DESCRIPTION_EN = "A high-energy day of athletics, discipleship, and joyful outreach for the Chosen Generation youth family.";
const CHOSEN_SPORTS_DAY_SHORT_DESCRIPTION_EN = "Full-day youth sports outreach with tournaments, testimonies, discipleship huddles, and a worship rally.";
const CHOSEN_SPORTS_DAY_LONG_DESCRIPTION_EN = "Chosen Sports Day channels competitive passion into kingdom purpose by gathering youth for spirited games that are framed by discipleship moments and encounters with Jesus.\n\nCoaches and pastors create teams that honor every participant, emphasize character, and foster servant-hearted leadership. Throughout the day testimonies, breakout huddles, and creative outreach moments keep the focus on transformation rather than trophies.\n\nWe end with a worship rally where students dedicate their gifts to the Lord and invite friends to surrender to Christ, ensuring that the energy of the field becomes momentum for revival.";

const CHOSEN_SPORTS_DAY_DESCRIPTION_AR = "يوم مليء بالطاقة يجمع شباب تشوزين في أنشطة رياضية، تلمذة، وخروج مبهج يعلن عن يسوع.";
const CHOSEN_SPORTS_DAY_SHORT_DESCRIPTION_AR = "يوم رياضي كامل للشباب يتضمن بطولات، شهادات، حلقات تلمذة، وتجمهراً للعبادة.";
const CHOSEN_SPORTS_DAY_LONG_DESCRIPTION_AR = "يحوّل يوم الرياضة للجيل المختار الشغف التنافسي إلى هدف ملكوتي، إذ يجمع الشباب في ألعاب ممتعة محاطة بلحظات تلمذة ولقاءات مع يسوع.\n\nالمدربون والرعاة يشكلون فرقاً تكرّم كل مشارك، وتؤكد على بناء الشخصية، وتغرس قيادة خادمة. طوال اليوم نحيا شهادات، حلقات نقاش، وفرص كرازية خلاقة تحافظ على تركيزنا على التحول وليس على الكؤوس.\n\nنختتم برالي عبادة يكرّس فيه الشباب مواهبهم للرب ويدعون أصدقاءهم للاستسلام للمسيح، لنحوّل طاقة الملعب إلى زخم نهضوي.";

const CHOSEN_SPORTS_DAY_EVENTS_EN: Event[] = CHOSEN_SPORTS_DAY_OCCURRENCES_2026.map((occurrence) => ({
  id: occurrence.id,
  key: `chosen-sports-day-${occurrence.slugSuffix}`,
  title: "Chosen Sports Day",
  description: CHOSEN_SPORTS_DAY_DESCRIPTION_EN,
  shortDescription: CHOSEN_SPORTS_DAY_SHORT_DESCRIPTION_EN,
  longDescription: CHOSEN_SPORTS_DAY_LONG_DESCRIPTION_EN,
  startDate: occurrence.startDate,
  endDate: occurrence.endDate,
  startTime: "09:00",
  endTime: "17:00",
  timezone: "GMT+2",
  address: ADDRESS_TBD_EN,
  category: EventCategory.SPORTS_DAY,
  tags: [...CHOSEN_SPORTS_DAY_TAGS_EN],
  status: EventStatus.UPCOMING,
  enrollment: {
    type: EnrollmentMode.NONE,
    isRequired: true,
    capacity: 320,
    enrolled: 0,
    deadline: occurrence.deadline,
    cost: {
      amount: 0,
      currency: "EGP"
    },
    formUrl: `https://docs.google.com/forms/d/e/1FAIpQLSfHjKlMnOpQrStUvWxYzAbCdEfGhIjKlMnOpQrStUvWxYzAbC/viewform?usp=header`
  },
  media: CHOSEN_SPORTS_DAY_MEDIA_EN,
  organizer: getMinistryById(MINISTRY_ID.CHOSEN_GENERATION_YOUTH, Language.EN)!,
  contactInfo: CHOSEN_GENERATION_CONTACT_EN,
  slug: `chosen-sports-day-${occurrence.slugSuffix}`,
  featured: false,
  priority: 3,
  languageSupport: ["English", "Arabic"],
  benefits: [...CHOSEN_SPORTS_DAY_BENEFITS_EN],
  createdAt: "2025-09-01T09:00:00Z",
  updatedAt: "2025-12-05T11:30:00Z"
}));

const CHOSEN_SPORTS_DAY_EVENTS_AR: Event[] = CHOSEN_SPORTS_DAY_OCCURRENCES_2026.map((occurrence) => ({
  id: occurrence.id,
  key: `chosen-sports-day-${occurrence.slugSuffix}`,
  title: "يوم الرياضة – تشوزين",
  description: CHOSEN_SPORTS_DAY_DESCRIPTION_AR,
  shortDescription: CHOSEN_SPORTS_DAY_SHORT_DESCRIPTION_AR,
  longDescription: CHOSEN_SPORTS_DAY_LONG_DESCRIPTION_AR,
  startDate: occurrence.startDate,
  endDate: occurrence.endDate,
  startTime: "09:00 AM",
  endTime: "05:00 PM",
  timezone: "GMT+2",
  address: ADDRESS_TBD_AR,
  category: EventCategory.SPORTS_DAY,
  tags: [...CHOSEN_SPORTS_DAY_TAGS_AR],
  status: EventStatus.UPCOMING,
  enrollment: {
    type: EnrollmentMode.MANDATORY,
    isRequired: true,
    capacity: 320,
    enrolled: 0,
    deadline: occurrence.deadline,
    cost: {
      amount: 150,
      currency: "EGP"
    },
    formUrl: `https://docs.google.com/forms/d/e/1FAIpQLSfHjKlMnOpQrStUvWxYzAbCdEfGhIjKlMnOpQrStUvWxYzAbC/viewform?usp=header`
  },
  media: CHOSEN_SPORTS_DAY_MEDIA_AR,
  organizer: getMinistryById(MINISTRY_ID.CHOSEN_GENERATION_YOUTH, Language.AR)!,
  contactInfo: CHOSEN_GENERATION_CONTACT_AR,
  slug: `chosen-sports-day-${occurrence.slugSuffix}`,
  featured: false,
  priority: 3,
  languageSupport: ["الإنجليزية", "العربية"],
  benefits: [...CHOSEN_SPORTS_DAY_BENEFITS_AR],
  createdAt: "2025-09-01T09:00:00Z",
  updatedAt: "2025-12-05T11:30:00Z"
}));
/*******************
 * Chosen Winter Conference
 *********************/
const CHOSEN_WINTER_CONFERENCE_TAGS_EN = ["Chosen Generation", "conference", "winter", "revival", "youth"];
const CHOSEN_WINTER_CONFERENCE_TAGS_AR = ["تشوزين", "مؤتمر", "شتاء", "نهضة", "شباب"];

const CHOSEN_WINTER_CONFERENCE_DESCRIPTION_EN = "Three-day winter conference igniting the Chosen Generation youth movement in worship, teaching, and mission.";
const CHOSEN_WINTER_CONFERENCE_SHORT_DESCRIPTION_EN = "Three-day youth revival gathering with prophetic worship, leadership labs, and city outreach.";
const CHOSEN_WINTER_CONFERENCE_LONG_DESCRIPTION_EN = "Chosen Winter Conference calls hundreds of students and young adults into a holy winter reset where hearts are reawakened to the voice of Jesus and the mandate of the gospel.\n\nAcross three days we blend morning formation tracks, leadership labs, creative breakouts, and city missions with extended evening worship where the prophetic flow is given full room.\n\nWe conclude with communion, testimonies, and a national sending moment that commissions every participant to carry revival fire back to campuses, churches, and streets.";

const CHOSEN_WINTER_CONFERENCE_DESCRIPTION_AR = "مؤتمر شتوي لمدة ثلاثة أيام يشعل شباب تشوزين في العبادة، التعليم، والإرسالية.";
const CHOSEN_WINTER_CONFERENCE_SHORT_DESCRIPTION_AR = "تجمع نهضوي للشباب لمدة ثلاثة أيام مع تسبيح نبوي، مختبرات قيادة، وخروج كرازي.";
const CHOSEN_WINTER_CONFERENCE_LONG_DESCRIPTION_AR = "يدعو مؤتمر الشتاء تشوزين إلى إعادة ضبط مقدسة يعاد فيها إحياء القلوب لسماع صوت يسوع وحمل أمانة الإنجيل.\n\nعلى مدار ثلاثة أيام نمزج مسارات التكوين الصباحية، مختبرات القيادة، الورش الإبداعية، والخدمة الميدانية مع أمسيات عبادة ممتدة يُفسح فيها المجال بالكامل لتدفق النبوة.\n\nنختتم بشركة المائدة، الشهادات، ولحظة إرسال وطنية تُفوِّض كل مشارك ليحمل نار النهضة إلى الجامعات والكنائس والشوارع.";

const CHOSEN_WINTER_CONFERENCE_EN: Event = {
  id: 13,
  key: "chosen-winter-conference-2026",
  title: "Chosen Winter Conference",
  description: CHOSEN_WINTER_CONFERENCE_DESCRIPTION_EN,
  shortDescription: CHOSEN_WINTER_CONFERENCE_SHORT_DESCRIPTION_EN,
  longDescription: CHOSEN_WINTER_CONFERENCE_LONG_DESCRIPTION_EN,
  startDate: "12-02-2026",
  endDate: "14-02-2026",
  startTime: "10:00",
  endTime: "21:30",
  timezone: "GMT+2",
  address: AGAPE_HOUSE_EN,
  category: EventCategory.CONFERENCE,
  tags: [...CHOSEN_WINTER_CONFERENCE_TAGS_EN],
  status: EventStatus.UPCOMING,
  enrollment: {
    type: EnrollmentMode.MANDATORY,
    isRequired: true,
    capacity: 800,
    enrolled: 0,
    deadline: "01-02-2026",
    cost: {
      amount: 1600,
      currency: "EGP"
    },
    formUrl: "https://docs.google.com/forms/d/e/1FAIpQLSdk3xGx8R2hAYRzDjlqeeNV77fFXBVRZ9Qhsd5iVTuY37qolA/viewform"
  },
  media: CHOSEN_WINTER_CONFERENCE_MEDIA_EN,
  organizer: getMinistryById(MINISTRY_ID.CHOSEN_GENERATION_YOUTH, Language.EN)!,
  contactInfo: { ...CHOSEN_GENERATION_CONTACT_EN },
  slug: "chosen-winter-conference-2026",
  featured: false,
  createdAt: "2025-11-15T08:30:00Z",
  updatedAt: "2025-12-10T16:00:00Z"
};

const CHOSEN_WINTER_CONFERENCE_AR: Event = {
  id: 13,
  key: "chosen-winter-conference-2026",
  title: "مؤتمر الشتاء – تشوزين",
  description: CHOSEN_WINTER_CONFERENCE_DESCRIPTION_AR,
  shortDescription: CHOSEN_WINTER_CONFERENCE_SHORT_DESCRIPTION_AR,
  longDescription: CHOSEN_WINTER_CONFERENCE_LONG_DESCRIPTION_AR,
  startDate: "12-02-2026",
  endDate: "14-02-2026",
  startTime: "10:00",
  endTime: "21:30",
  timezone: "GMT+2",
  address: AGAPE_HOUSE_AR,
  category: EventCategory.CONFERENCE,
  tags: [...CHOSEN_WINTER_CONFERENCE_TAGS_AR],
  status: EventStatus.UPCOMING,
  enrollment: {
    type: EnrollmentMode.MANDATORY,
    isRequired: true,
    capacity: 800,
    enrolled: 0,
    deadline: "01-02-2026",
    cost: {
      amount: 1600,
      currency: "EGP"
    },
    formUrl: "https://docs.google.com/forms/d/e/1FAIpQLSdk3xGx8R2hAYRzDjlqeeNV77fFXBVRZ9Qhsd5iVTuY37qolA/viewform"
  },
  media: CHOSEN_WINTER_CONFERENCE_MEDIA_AR,
  organizer: getMinistryById(MINISTRY_ID.CHOSEN_GENERATION_YOUTH, Language.AR)!,
  contactInfo: { ...CHOSEN_GENERATION_CONTACT_AR },
  slug: "chosen-winter-conference-2026",
  featured: false,
  createdAt: "2025-11-15T08:30:00Z",
  updatedAt: "2025-12-10T16:00:00Z"
};
/*******************
 * Chosen Summer Conference
 *********************/
const CHOSEN_SUMMER_CONFERENCE_TAGS_EN = ["Chosen Generation", "conference", "summer", "revival", "youth"];
const CHOSEN_SUMMER_CONFERENCE_TAGS_AR = ["تشوزين", "مؤتمر", "صيف", "نهضة", "شباب"];


const CHOSEN_SUMMER_CONFERENCE_DESCRIPTION_EN = "A three-day summer intensive for Chosen Generation youth that fuses discipleship, creativity, and mission.";
const CHOSEN_SUMMER_CONFERENCE_SHORT_DESCRIPTION_EN = "Three-day summer intensive with morning activations, afternoon outreach, and nightly revival services.";
const CHOSEN_SUMMER_CONFERENCE_LONG_DESCRIPTION_EN = "Chosen Summer Conference positions students for a mid-year surge of passion, holiness, and kingdom creativity.\n\nMorning encounter tracks and coaching circles address identity, emotional health, and leadership resilience, while afternoons launch teams into evangelism, service projects, and creative expressions of the gospel.\n\nEvery evening culminates in a Spirit-breathed revival service followed by practical commissioning so participants return home carrying strategy, community, and fresh fire.";

const CHOSEN_SUMMER_CONFERENCE_DESCRIPTION_AR = "مؤتمر صيفي مكثف لمدة ثلاثة أيام لشباب تشوزين يمزج بين التلمذة، الإبداع، والإرسالية.";
const CHOSEN_SUMMER_CONFERENCE_SHORT_DESCRIPTION_AR = "مكثف صيفي لمدة ثلاثة أيام مع تفعيل صباحي، خروج بعد الظهر، واجتماعات نهضوية مسائية.";
const CHOSEN_SUMMER_CONFERENCE_LONG_DESCRIPTION_AR = "يضع مؤتمر الصيف تشوزين في موجة منتصف العام من الشغف، القداسة، والإبداع الملكوتي.\n\nمسارات الصباح التفعيلية ودوائر التدريب تعالج الهوية والصحة النفسية ومرونة القيادة، بينما تطلق فترات بعد الظهر الفرق في الكرازة، مشروعات الخدمة، والتعبيرات الإبداعية للإنجيل.\n\nتتوج كل سهرة باجتماع نهضوي يقوده الروح، يعقبه إرسال عملي كي يعود المشاركون مزودين باستراتيجيات، وشركة، ونار متجددة.";


const CHOSEN_SUMMER_CONFERENCE_EN: Event = {
  id: 14,
  key: "chosen-summer-conference-2026",
  title: "Chosen Summer Conference",
  description: CHOSEN_SUMMER_CONFERENCE_DESCRIPTION_EN,
  shortDescription: CHOSEN_SUMMER_CONFERENCE_SHORT_DESCRIPTION_EN,
  longDescription: CHOSEN_SUMMER_CONFERENCE_LONG_DESCRIPTION_EN,
  startDate: "09-07-2026",
  endDate: "11-07-2026",
  startTime: "10:00",
  endTime: "22:00",
  timezone: "GMT+2",
  address: AGAPE_HOUSE_EN,
  category: EventCategory.CONFERENCE,
  tags: [...CHOSEN_SUMMER_CONFERENCE_TAGS_EN],
  status: EventStatus.UPCOMING,
  enrollment: {
    type: EnrollmentMode.MANDATORY,
    isRequired: true,
    capacity: 900,
    enrolled: 0,
    deadline: "25-06-2026",
    cost: {
      amount: 1100,
      currency: "EGP"
    },
    formUrl: "https://docs.google.com/forms/d/e/1FAIpQLSeRcDeFgHiJkLmNoPqRsTuVwXyZaBcDeFgHiJkLmNoPqRsT/viewform?usp=header"
  },
  media: CHOSEN_SUMMER_CONFERENCE_MEDIA_EN,
  organizer: getMinistryById(MINISTRY_ID.CHOSEN_GENERATION_YOUTH, Language.EN)!,
  contactInfo: { ...CHOSEN_GENERATION_CONTACT_EN },
  slug: "chosen-summer-conference-2026",
  featured: false,
  createdAt: "2025-11-20T08:30:00Z",
  updatedAt: "2025-12-18T14:00:00Z"
};

const CHOSEN_SUMMER_CONFERENCE_AR: Event = {
  id: 14,
  key: "chosen-summer-conference-2026",
  title: "مؤتمر الصيف – تشوزين",
  description: CHOSEN_SUMMER_CONFERENCE_DESCRIPTION_AR,
  shortDescription: CHOSEN_SUMMER_CONFERENCE_SHORT_DESCRIPTION_AR,
  longDescription: CHOSEN_SUMMER_CONFERENCE_LONG_DESCRIPTION_AR,
  startDate: "07-07-2026",
  endDate: "09-07-2026",
  startTime: "10:00 AM",
  endTime: "10:00 PM",
  timezone: "GMT+2",
  address: AGAPE_HOUSE_AR,
  category: EventCategory.CONFERENCE,
  tags: [...CHOSEN_SUMMER_CONFERENCE_TAGS_AR],
  status: EventStatus.UPCOMING,
  enrollment: {
    type: EnrollmentMode.MANDATORY,
    isRequired: true,
    capacity: 900,
    enrolled: 0,
    deadline: "25-06-2026",
    cost: {
      amount: 1050,
      currency: "EGP"
    },
    formUrl: "https://docs.google.com/forms/d/e/1FAIpQLSeRcDeFgHiJkLmNoPqRsTuVwXyZaBcDeFgHiJkLmNoPqRsT/viewform?usp=header"
  },
  media: CHOSEN_SUMMER_CONFERENCE_MEDIA_AR,
  organizer: getMinistryById(MINISTRY_ID.CHOSEN_GENERATION_YOUTH, Language.AR)!,
  contactInfo: { ...CHOSEN_GENERATION_CONTACT_AR },
  slug: "chosen-summer-conference-2026",
  featured: false,
  createdAt: "2025-11-20T08:30:00Z",
  updatedAt: "2025-12-18T14:00:00Z"
};

/*******************
 * Events
 *********************/
const EVENTS_MOCK_DATA_EN: Event[] = [
  ...MONTHLY_WORSHIP_EVENTS_EN,
  CHOSEN_WINTER_CONFERENCE_EN,
  CHOSEN_SUMMER_CONFERENCE_EN,
  ...CHOSEN_SPORTS_DAY_EVENTS_EN,
  ...YOUTH_MINISTRY_EVENTS_EN
];

const EVENTS_MOCK_DATA_AR: Event[] = [
  ...MONTHLY_WORSHIP_EVENTS_AR,
  CHOSEN_WINTER_CONFERENCE_AR,
  CHOSEN_SUMMER_CONFERENCE_AR,
  ...CHOSEN_SPORTS_DAY_EVENTS_AR,
  ...YOUTH_MINISTRY_EVENTS_AR
];
/*******************
 *  Get Localized Events with Pagination
 *********************/
export const getEventsLocalized = (
  language: Language = Language.EN,
  fetchAll: boolean = false,
  page: number = 1,
  limit: number = 10
): PaginatedResult<Event> => {
  const events = language === Language.AR ? EVENTS_MOCK_DATA_AR : EVENTS_MOCK_DATA_EN;
  const actualLimit = fetchAll ? -1 : limit;
  return PaginationUtil.paginate<Event>(events, page, actualLimit);
};
